import { AlertTriangle, CheckCircle2, Clock3, GitPullRequestArrow, Inbox, UserRound } from 'lucide-react';
import type { SedFilterCounts, SedQuickFilter } from '@/lib/sed';
import { cn } from '@/lib/utils';

const FILTERS: { value: SedQuickFilter; label: string; Icon: typeof Inbox }[] = [
  { value: 'all', label: 'Все', Icon: Inbox },
  { value: 'mine', label: 'Мои', Icon: UserRound },
  { value: 'approving', label: 'На согласовании', Icon: GitPullRequestArrow },
  { value: 'signed', label: 'Подписаны', Icon: CheckCircle2 },
  { value: 'overdue', label: 'Просрочены', Icon: AlertTriangle },
];

export function SedQuickFilters({
  value,
  counts,
  showSigned,
  onChange,
}: {
  value: SedQuickFilter;
  counts: SedFilterCounts;
  showSigned: boolean;
  onChange: (value: SedQuickFilter) => void;
}) {
  return (
    <div className="-mx-3 overflow-x-auto px-3 pb-1 [scrollbar-width:none] [&::-webkit-scrollbar]:hidden">
      <div className="flex w-max items-center gap-1.5">
        {FILTERS.filter((item) => showSigned || item.value !== 'signed').map(({ value: filter, label, Icon }) => {
          const active = value === filter;
          const count = counts[filter];
          return (
            <button
              key={filter}
              type="button"
              onClick={() => onChange(filter)}
              aria-pressed={active}
              className={cn(
                'inline-flex h-8 items-center gap-1.5 rounded-full border px-2.5 text-xs font-medium whitespace-nowrap transition-colors',
                active
                  ? 'border-primary/40 bg-primary/15 text-primary'
                  : 'border-border bg-card text-muted-foreground hover:bg-accent hover:text-foreground',
              )}
            >
              <Icon className="h-3.5 w-3.5" />
              <span>{label}</span>
              {count > 0 && (
                <span
                  className={cn(
                    'rounded-full px-1.5 text-[10px] tabular-nums',
                    active ? 'bg-primary/15 text-primary' : 'bg-muted text-muted-foreground',
                  )}
                >
                  {count}
                </span>
              )}
            </button>
          );
        })}
        <span className="ml-1 inline-flex items-center gap-1 text-[10px] text-muted-foreground">
          <Clock3 className="h-3 w-3" />
          сроки по датам документов
        </span>
      </div>
    </div>
  );
}
